import global from "../global.js";
const log = global.log.getLogger("f_mtac.ui.InputTextArea");
log.setLevel(log.levels.WARN);

let InputTextArea = function () {
    var {Modal} = window.f_mtac_theme;
    var input_text_area_modal;
    var $input_text_area = document.getElementById("input_text_area");

    const capitalize = function (text) {
        return text === "" ? text : text.charAt(0).toUpperCase() + text.substr(1);
    };

    /*
     * validators: e.g. {required: true, pattern: ".{1,36}"}
     */
    this.interact = function ({current_text = "", tip, capitalized = true, uppercase, validators, error_message = ""}) {
        input_text_area_modal = new Modal($input_text_area);
        let text = null;

        // Prepare the view
        $("#input_text_area input").css("text-transform", uppercase ? "uppercase" : "none");
        for (let validator in validators) {
            $("#input_text_area input").attr(validator, validators[validator]);
        }
        $("#input_text_area .modal-title").text(tip);
        $("#input_text_area input").val(current_text);
        $("#input_text_area .invalid-feedback").text(error_message);

        // User actions handlers
        let handlers = {
            ok: () => {
                if (!$("#input_text_area input")[0].checkValidity()) {
                    $("#input_text_area input").addClass("is-invalid");
                    $("#input_text_area button[data-method='ok']").attr("disabled", true);
                    return;
                }
                text = $("#input_text_area input").val();
                text = capitalized ? capitalize(text) : text;
                input_text_area_modal.hide();
            },
            cancel: () => {
                input_text_area_modal.hide();
            }
        };

        // Manage events
        $input_text_area.addEventListener("shown.bs.modal", function () {
            $("#input_text_area input").trigger("focus");
            $("#input_text_area input")[0].setSelectionRange(0, current_text.length);
        });

        $("body").on("click.input_text_area.btn", "#input_text_area .btn", (event) => {
            let method = $(event.currentTarget).data("method");
            log.debug(`${method} pressed.`);
            handlers[method]();
        });

        $("#input_text_area input").on("blur keyup paste", (event) => {
            // Check validity
            if (!$("#input_text_area input")[0].checkValidity()) {
                $("#input_text_area input").addClass("is-invalid");
                $("#input_text_area button[data-method='ok']").attr("disabled", true);
                return;
            }
            $("#input_text_area input").removeClass("is-invalid");
            $("#input_text_area button[data-method='ok']").removeAttr("disabled");
            if (["Delete", "Backspace"].includes(event.key) === true) {
                // Do not capitalize when deleting characters.
                return;
            }
            if (capitalized) {
                let text = $("#input_text_area input").val();
                $("#input_text_area input").val(capitalize(text));
            }
        });

        $("body").on("keydown", "#input_text_area input", async (event) => {
            log.debug("Enter pressed.");
            if (event.key === "Enter") {
                event.preventDefault();
                handlers["ok"]();
            }
        });

        return new Promise((resolve) => {
            let interaction_end = () => {
                for (let validator in validators) {
                    $("#input_text_area input").removeAttr(validator);
                }
                $input_text_area.removeEventListener("shown.bs.modal", interaction_end);
                $input_text_area.removeEventListener("hidden.bs.modal", interaction_end);
                $("body").off("click.input_text_area.btn", "#input_text_area .btn");
                $("body").off("keydown", "#input_text_area input");
                $("#input_text_area input").off("blur keyup paste");
                log.debug("Interaction ended with text:", text);
                resolve(text);
            };

            $input_text_area.addEventListener("hidden.bs.modal", interaction_end);
            input_text_area_modal.show();
        });
    };
};
export default new InputTextArea();
